
import { PartCategory } from '@/models/PartCategory'
import { BasePicturesModel } from '@/models/BasePicturesModel'
import { Children } from '../Children'

export class InputParent extends BasePicturesModel {
	static fields () {
		return {
			id: null,
			name: null,
			title: null,
			category: PartCategory,
			nearestChildren: {
				id: null
			},
			oemCodes: {
				id: null,
				code: null,
				isPrimary: false
			},
			location: {
				id: null,
				name: null
			},
			pictures: {
				id: null,
				url: null
			},
			comment: null,
			isGroupedSale: false
		}
	}

	static hasMany () {
		return {
			children: Children
		}
	}
}
export function createInputParent (data) {
	return Object.freeze(new InputParent(data))
}
